// import
import Dashboard from "views/Dashboard/Dashboard.js";
import Dashboard2 from "views/Dashboard2/Dashboard.js";

import {
  HomeIcon,
} from "components/Icons/Icons";

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "Visão Geral",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/dashboard2",
    name: "Dashboard2",
    rtlName: "Visão Geral",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard2,
    layout: "/admin",
  },
];
export default dashRoutes;
